import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { citiesUnPopularListQuery } from '../../../queries';
import { setError } from '../../../actions';
import { regionsQuery } from '../../../queries/regions';
import { sortIntoVerticalColumns } from '../../../utils/helpers/sortIntoVerticalColumns';
import FooterLocationsPlaceholder from '../../Placeholders/FooterLocationsPlaceholder';
import {
  LocationsBlock,
  LocationsContainer,
  LocationsTitle,
  LocationTitle
} from './styled';

const Locations = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    data: citiesData,
    loading: citiesLoading,
    error: citiesError
  } = useQuery(citiesUnPopularListQuery);

  const locationsQueryVariables = { cityId: 1 };
  const {
    data: regionsData,
    loading: regionsLoading,
    error: regionsError
  } = useQuery(regionsQuery(locationsQueryVariables), {
    variables: locationsQueryVariables
  });

  const cities = citiesData?.cities || [];
  const regions = regionsData?.regions || [];

  const columns = 7;
  const verticallyOrganizedCities = sortIntoVerticalColumns(cities, columns);

  useEffect(() => {
    if (citiesError || regionsError) dispatch(setError(true));
  }, [citiesError, regionsError]);

  return (
    <LocationsContainer data-cy="locations">
      {regionsLoading ? (
        <FooterLocationsPlaceholder />
      ) : (
        <>
          <LocationsTitle data-cy="areas-title">
            {t('common.baki_areas')}
          </LocationsTitle>
          <LocationsBlock data-cy="areas-block">
            {regions.map(region => {
              return (
                <LocationTitle
                  data-cy="area"
                  key={region.slug}
                  href={`/${region.slug}`}
                >
                  {region.name}
                </LocationTitle>
              );
            })}
          </LocationsBlock>
        </>
      )}

      {citiesLoading ? (
        <FooterLocationsPlaceholder />
      ) : (
        <>
          <LocationsTitle data-cy="cities">
            {t('common.all_country')}
          </LocationsTitle>
          <LocationsBlock data-cy="cities-block">
            {verticallyOrganizedCities.map((city, index) => {
              return (
                <LocationTitle
                  data-cy="cities-item-link"
                  key={`${city?.id}_${index}`}
                  href={`/${city?.slug}`}
                >
                  {city?.name}
                </LocationTitle>
              );
            })}
          </LocationsBlock>
        </>
      )}
    </LocationsContainer>
  );
};

export default Locations;
